/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PipelineInputs */

const cs_nav_pipeline = /** @type {(inputs: Nav_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

const en_nav_pipeline = /** @type {(inputs: Nav_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

/**
* | output |
* | --- |
* | "Pipeline" |
*
* @param {Nav_PipelineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_pipeline = /** @type {((inputs?: Nav_PipelineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PipelineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_pipeline(inputs)
	return cs_nav_pipeline(inputs)
});